import React, { Component } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
    return {
        dist: state.appReducer.dist,
    };
};

class Main extends Component {
    constructor(props) {
        super(props);
        window.startDist();
    }

    render() {
        return (
            <div className="TopBtnSwS">
                <div className="l-row">
                    <label>距離 [km]：</label>
                    <p>{(this.props.dist / 1000).toFixed(2)}</p>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Main);
